module.exports = __webpack_public_path__ + "static/media/acorn-thumb.032ee3df.png";